<template>
  <div class="game-is-on">
    <ScoreBar />

    <div class="playing-area">
      <span class="phase-indicator">Ronde {{ roundNumber }} bezig</span>

      <div v-if="contractState" class="contract-card">
        <span class="contract-name">{{ contractState.label }}</span>
        <div class="contract-details">
          <span v-if="contractState.suitSymbol" class="contract-suit" :class="{ red: contractState.suitRed }">
            {{ contractState.suitSymbol }}
          </span>
          <span v-if="contractState.tricks" class="contract-tricks">{{ contractState.tricks }} slagen</span>
        </div>
        <div class="contract-players">
          <span
            v-for="id in contractState.playerIds"
            :key="id"
            class="contract-player"
          >{{ playerName(id) }}</span>
        </div>
      </div>

      <SuitMorph v-else />
    </div>

    <AppFooter
      :show-back="true"
      continue-label="Resultaat invoeren"
      @back="setView('round')"
      @continue="enterResult"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useGameStore } from '../../stores/game'
import { useContractStore } from '../../stores/contract'
import ScoreBar from '../shared/ScoreBar.vue'
import AppFooter from '../shared/AppFooter.vue'
import SuitMorph from '../shared/SuitMorph.vue'

export default {
  name: 'GameIsOn',
  components: { ScoreBar, AppFooter, SuitMorph },
  computed: {
    ...mapState(useGameStore, ['roundNumber', 'players']),
    ...mapState(useContractStore, ['contractState']),
  },
  methods: {
    ...mapActions(useGameStore, ['setView']),
    enterResult() {
      this.setView('result')
    },
    playerName(id) {
      const p = this.players.find(pl => pl.id === id)
      return p ? p.name : ''
    },
  },
}
</script>

<style scoped>
.game-is-on {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.playing-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.phase-indicator {
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #fff;
  background-color: #2c3e50;
  padding: 0.3em 0.9em;
  border-radius: 999px;
}

.contract-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  background: #fff;
  border-radius: 16px;
  padding: 2rem 2.75rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  min-width: 260px;
}

.contract-name {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2c3e50;
}

.contract-details {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.contract-suit {
  font-size: 2.4rem;
  line-height: 1;
  color: #2c3e50;
}
.contract-suit.red { color: #c0392b; }

.contract-tricks {
  font-size: 1.15rem;
  font-weight: 600;
  color: #555;
}

.contract-players {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  justify-content: center;
}

.contract-player {
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  background-color: #2c3e50;
  padding: 0.25em 0.7em;
  border-radius: 999px;
}
</style>
